import type { FaireProductEntity } from "../../entity_types/product";

export const p_jj36k2f95z: FaireProductEntity = {
  token: "p_jj36k2f95z",
  type: "product",
  name: "Sample Pack - Skincare Mini Set (10 products)",
  brandToken: "b_8pygbzi7",
  brandName: "FABLERUNE",
  imageUrl:
    "https://cdn.faire.com/fastly/b82734d5276b7be7832c7b6a6345fc54fb0de6c304a7ac35b714ed17111e6c70.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d6480d7ca5af78fe987849f2cbf4d9f69fb24b15451f5bd0da1ebf8e59a74d1f.jpeg",
    "https://cdn.faire.com/fastly/9d61a3753643cc223d2eab39953d0540b7acf2bbd16252f32502e3949d9495e7.jpeg",
    "https://cdn.faire.com/fastly/cb22b0b7bc7654991ed1c0092f19440e2a951735c597c64fc4c0961227fd4f8b.jpeg",
    "https://cdn.faire.com/fastly/9105baa96d023aeb5754fd3fb3dc7bc9eb848fa2cd6c68fa2f70d107d6a37e00.jpeg",
  ],
  priceDollars: 69,
  description:
    "Not for resale - limit 1 per customer - for sampling only.\n\nThis is a great way to test our skincare line, it includes a mini size of our entire facial line.\n\nOur Skincare Sample Pack includes 10 products:\n\n• 1oz - Rose Clay & Lavender Cleanser\n• 1oz - Sea Clay & Tea Tree Cleanser\n• 1oz - Turmeric Charcoal & Copaiba Cleanser\n• 1oz - Neroli & Frankincense Hydrating Facial Mist\n• 0.5oz - Agave & Golden Algae Vital Day Cream\n• 0.5oz - Rosehip & Algae Mud Scrub\n• 0.5oz - Probiotic & Kelp Marine Mask\n• 0.5oz - Sea Clay & Goat Milk Mask\n• 0.5oz - Rose Clay & Goat Milk Mask\n• 8ml - Copaiba & Tamanu Balancing Facial Oil",
  tags: [],
  msrpDollars: 130,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:36.000Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
